
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { message } from 'ant-design-vue';
import numeral from 'numeral';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';
import { addToCart } from '@/api/apis';
import { validateQuantity, validateLength } from '@/utils/validate';

interface AddPartToCartModalProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'AddPartToCartModal',
  emits: ['after-close'],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    groupId: {
      type: Number,
      default: null
    },
    vehicleId: {
      type: Number,
      default: null
    },
    isSpare: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EnlargeIcon,
    PreviewImageModal,
    MinusOutlined,
    PlusOutlined
  },
  data(): AddPartToCartModalProps {
    return {
      validateLength,
      validateQuantity,
      visible: true,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        modelNum: this.item.modelNum,
        partCode: this.item.partCode,
        quantity: '1',
        remark: ''
      },
      baseFileUrl,
      showPreviewModal: false,
      previewImg: [],
      isCancel: true
    };
  },
  computed: {
    ...mapState(['userInfo']),
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0) {
        res = baseFileUrl + partsImgs[0].fileUrl;
      }

      return res;
    }
  },
  methods: {
    handleAfterClose() {
      this.$emit('after-close', this.isCancel);
    },
    handleQuantityChange() {
      const quantity = +this.form.quantity;
      if (quantity > 9999) {
        this.form.quantity = '9999';
      }

      if (quantity === 0) {
        this.form.quantity = '1';
      }
    },
    substract() {
      const quantity = Number(this.form.quantity);
      if (!isNaN(quantity) && quantity > 1) {
        this.form = {
          ...this.form,
          quantity: String(quantity - 1)
        } as any;

        const form = (this.$refs as any).form;

        form.clearValidate('quantity');
      }
    },
    add() {
      const quantity = Number(this.form.quantity || 0);
      if (quantity < 9999) {
        this.form = {
          ...this.form,
          quantity: String(quantity + 1)
        } as any;
        const form = (this.$refs as any).form;
        form.clearValidate('quantity');
      }
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addToCart({
            ...this.form,
            quantity: numeral(this.form.quantity).value(),
            customerId: this.userInfo.id,
            modelNum: this.item.modelNum,
            name: this.item.partName,
            partCode: this.item.partCode,
            groupName: this.item.groupName,
            unit: this.item.unit,
            unitPrice: this.item.sellingPrice,
            consignee: this.userInfo.companyName,
            shoppingType: 2, // 子配件
            groupId: this.groupId,
            vehicleId: this.vehicleId,

            partsId: this.item.id
          });
          if (res.success) {
            this.isCancel = false;
            this.handleCancel();

            message.success(this.$t(res.message));
          }

          this.loading = false;
        })
        .catch();
    },
    onImgClick() {
      this.previewImg.push(
        ...(this.item.partsImgs || [])
          .filter(s => s.fileUrl)
          .map(s => baseFileUrl + s.fileUrl)
      );
      this.showPreviewModal = true;
    },
    handleAfterImgModalClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    }
  }
});
